
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";

interface EdgeFunctionLog {
  timestamp: string;
  message: string;
}

interface EdgeFunctionLogsProps {
  logs: EdgeFunctionLog[];
  title?: string;
}

export const EdgeFunctionLogs: React.FC<EdgeFunctionLogsProps> = ({
  logs,
  title = "Edge Function Logs"
}) => {
  if (!logs || logs.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No edge function logs available</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm flex items-center gap-2">
          {title}
          <Badge variant="outline" className="text-xs">
            {logs.length} logs
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-32 w-full">
          <div className="space-y-2">
            {logs.map((log, index) => (
              <div key={index} className="flex items-start gap-2 text-xs">
                <Clock className="h-3 w-3 mt-0.5 text-muted-foreground flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-muted-foreground">
                    {new Date(log.timestamp).toLocaleTimeString()}
                  </div>
                  <div className="text-foreground break-words">
                    {log.message}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
